'use strict';

angular.module('accessWebClient')
    .directive('accChipsInputSuggestions', [
        'debounce',
        'template',
        (
            debounce,
            template
        ) => ({
            replace: true,
            restrict: 'E',
            scope: true,
            templateUrl: template('nodes/_chips_input_suggestions'),
            link: ($scope) => {
                $scope.highlightedItemIndex = 0;
                $scope.suggestions = [];

                const SUGGESTIONS_DELAY = 300;

                $scope.$watch('inputValue', debounce((query) => {
                    if (!query || query.length < 1) {
                        _resetSuggestions();
                        $scope.$digest();
                        return;
                    }

                    const response = $scope.loadSuggestions({ query });
                    // $scope.loadSuggestion must return a Promise
                    if (!angular.isObject(response) || !angular.isFunction(response.then)) {
                        return;
                    }

                    response.then((suggestions) => {
                        $scope.suggestions = suggestions;
                        $scope.$digest();
                    });
                }, SUGGESTIONS_DELAY));

                $(document).on('keydown', _onKeyDownHandler);

                $scope.$on('$destroy', () => $(document).off('keyup', _onKeyDownHandler));

                function _onKeyDownHandler(event) {
                    if ($scope.suggestions.length < 1) {
                        return;
                    }

                    switch (event.key) {
                        case 'ArrowUp':
                            event.preventDefault();
                            $scope.highlightedItemIndex = Math.max(
                                $scope.highlightedItemIndex - 1,
                                0
                            );
                            break;

                        case 'ArrowDown':
                            event.preventDefault();
                            $scope.highlightedItemIndex = Math.min(
                                $scope.highlightedItemIndex + 1,
                                $scope.suggestions.length - 1
                            );
                            break;

                        case 'Enter':
                            $scope.select($scope.suggestions[$scope.highlightedItemIndex]);
                            break;

                        case 'Escape':
                            _resetSuggestions();
                            break;
                    }

                    $scope.$digest();
                };

                $scope.select = (suggestion) => {
                    $scope.selectSuggestion(suggestion.value);
                    _resetSuggestions();
                };

                function _resetSuggestions() {
                    $scope.highlightedItemIndex = 0;
                    $scope.suggestions = [];
                }
            }
        })
    ]);
